// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tbl_search th[data-v-741168c0] {vertical-align: top;}\n", ""]);
// Exports
module.exports = exports;
